import { cn } from '@/lib/utils';
import type { EvaluationStatus } from '@/types/stock';

interface Props {
  status: EvaluationStatus;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const STATUS_CONFIG: Record<EvaluationStatus, { label: string; className: string }> = {
  PASS: {
    label: 'PASS',
    className: 'bg-emerald-100 text-emerald-800 border border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800',
  },
  FAIL: {
    label: 'FAIL',
    className: 'bg-red-100 text-red-800 border border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-800',
  },
  WATCH: {
    label: 'WATCH',
    className: 'bg-amber-100 text-amber-800 border border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800',
  },
  PENDING: {
    label: 'PENDING',
    className: 'bg-gray-100 text-gray-600 border border-gray-200 dark:bg-gray-800/50 dark:text-gray-400 dark:border-gray-700',
  },
};

const SIZE_CLASSES = {
  sm: 'text-xs px-1.5 py-0.5 rounded',
  md: 'text-xs px-2 py-0.5 rounded-md font-semibold',
  lg: 'text-sm px-3 py-1 rounded-md font-bold',
};

export function StatusBadge({ status, size = 'md', className }: Props) {
  const config = STATUS_CONFIG[status];
  return (
    <span className={cn(config.className, SIZE_CLASSES[size], 'inline-flex items-center', className)}>
      {config.label}
    </span>
  );
}
